import { jsx as _jsx } from "react/jsx-runtime";
import { FooterWrapper } from './Footer.style';
const Footer = ({ children }) => (_jsx(FooterWrapper, { children: children }));
export default Footer;
